// import { Message } from 'element-ui'
import { getHomePageData } from '../../api/dashboard'

const home = {
    state: {
        orderData: {
            afterSaleWarnCount: 0,
            exchangeCont: 0,
            pickCount: 0,
            replenishCount: 0,
            returnCount: 0,
            waitDeliverCount: 0
        },
        total: 0
    },
    mutations: {
        SET_ORDER_DATA: (state, payload) => {
            state.orderData = null
            state.orderData = payload
        },
        SET_ORDER_TOTAL: (state, n) => {
            state.total = null
            state.total = n
        }
    },
    actions: {
        GetHomeOrderData: async ({ commit }) => {
            // 开关控制 如果没有权限 则不再调用
            let flag = false
            if (!flag) {
                const { code, data } = await getHomePageData()
                if (+code === 0) {
                    data.exchangeCont = data.exchangeCont || 0
                    data.pickCount = data.pickCount || 0
                    data.replenishCount = data.replenishCount || 0
                    data.returnCount = data.returnCount || 0
                    let total = data.exchangeCont + data.pickCount + data.replenishCount + data.returnCount
                    commit('SET_ORDER_DATA', data)
                    commit('SET_ORDER_TOTAL', total)

                    flag = false
                    return data
                } else {
                    // Message.error(msg || '请求失败')
                    flag = true
                }
            }
        }
    }
}

export default home
